(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function progressFor(element, startMode) {
    var rect = element.getBoundingClientRect();
    var viewport = window.innerHeight || document.documentElement.clientHeight;
    if (startMode === 'hero') {
      return clamp((0 - rect.top) / Math.max(1, rect.height), 0, 1);
    }
    return clamp((viewport - rect.top) / Math.max(1, rect.height), 0, 1);
  }

  function setTransform(element, transform) {
    if (element) element.style.transform = transform;
  }

  function renderHero(hero) {
    var p = progressFor(hero, 'hero');
    setTransform(hero.querySelector('[data-hero-layer="bg"]'), 'translate3d(0,' + (p * 0.5) + '%,0)');
    setTransform(hero.querySelector('[data-hero-layer="rays"]'), 'translate3d(0,' + (p * -8) + '%,0) rotate(' + (p * 5.5) + 'deg) scale(' + (1 + p * 0.1) + ')');
    setTransform(hero.querySelector('[data-hero-layer="haze"]'), 'translate3d(0,' + p + '%,0)');
    setTransform(hero.querySelector('[data-hero-layer="water"]'), 'translate3d(0,' + (p * 6) + '%,0)');
  }

  function renderWave(wave) {
    var p = progressFor(wave, 'wave');
    var y = -6 + (6 * p);
    setTransform(wave.querySelector('[data-wave-group="water"]'), 'translate3d(0,' + y + '%,0)');
  }

  function initParallax() {
    var heroes = Array.prototype.slice.call(document.querySelectorAll('[data-ssbc-hero]'));
    var waves = Array.prototype.slice.call(document.querySelectorAll('[data-ssbc-wave]'));
    if (reduceMotion.matches || (!heroes.length && !waves.length)) return;

    var ticking = false;
    function render() {
      heroes.forEach(renderHero);
      waves.forEach(renderWave);
      ticking = false;
    }
    function requestRender() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    }
    render();
    window.addEventListener('scroll', requestRender, { passive: true });
    window.addEventListener('resize', requestRender);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initParallax);
  } else {
    initParallax();
  }
})();
